export default function normalizeWhitespace(value) {
    return value.trim().replace(/[^\S\r\n]+/g, " ");
}
